module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-tap-event-plugin/src/defaultClickRejectionStrategy.js
// module id = 798
// module chunks = 0